//
// The assignment types consists of:
// - inspection types
// - review types
//
define(function(){
	const GenericCollection = require('civicsBase/generic_collection');
	const ASSIGNMENT_TYPES_DESCRIPTION_MAX_DISPLAY_LENGTH = 50;

	var assignmentTypeParse = function (data) {
		// loop thru the data for a given dataType
		var dataNew = {};
		for (i = 0; i < data.length; i++) {
			dataNew = data[i].inspectionType ? data[i].inspectionType : data[i].reviewType;
	    var computedDescription =
	        Handlebars.helpers['global:computedDescription'](dataNew.portalDescription, dataNew.description);
	    dataNew.computedDescription = computedDescription;
	    dataNew.computedDescriptionShort =
	        Handlebars.helpers['global:limitLength'](computedDescription, ASSIGNMENT_TYPES_DESCRIPTION_MAX_DISPLAY_LENGTH);
			dataNew.showInPortal = data[i].application.applicationType.showInPortal;
			data[i] = dataNew;
		}
		return data;
	};

	return GenericCollection.extend({
		dataTypeContext : [{
			type: 'building.Inspection',
			url: 'cdr/inspections/Building',
			collectionParse: assignmentTypeParse
		}, {
			type: 'building.Review',
			url: 'cdr/reviews/Building',
			collectionParse: assignmentTypeParse
		}, {
			type: 'businessLicense.Inspection',
			url: 'cdr/inspections/BusinessLicense',
			collectionParse: assignmentTypeParse
		}, {
			type: 'businessLicense.Review',
			url: 'cdr/reviews/BusinessLicense',
			collectionParse: assignmentTypeParse
		}, {
			type: 'codeEnforcement.Inspection',
			url: 'cdr/inspections/CodeEnforcement',
			collectionParse: assignmentTypeParse
		}, {
			type: 'codeEnforcement.Review',
			url: 'cdr/reviews/CodeEnforcement',
			collectionParse: assignmentTypeParse
		}, {
			type: 'planning.Inspection',
			url: 'cdr/inspections/Planning',
			collectionParse: assignmentTypeParse
		}, {
			type: 'planning.Review',
			url: 'cdr/reviews/Planning',
			collectionParse: assignmentTypeParse
		}, {
			type: 'project.Inspection',
			url: 'cdr/inspections/Project',
			collectionParse: assignmentTypeParse
		}, {
			type: 'project.Review',
			url: 'cdr/reviews/Project',
			collectionParse: assignmentTypeParse
		}, {
			type: 'tradeLicense.Inspection',
			url: 'cdr/inspections/TradeLicense',
			collectionParse: assignmentTypeParse
		}, {
			type: 'tradeLicense.Review',
			url: 'cdr/reviews/TradeLicense',
			collectionParse: assignmentTypeParse
		}, {
			type: 'use.Inspection',
			url: 'cdr/inspections/Use',
			collectionParse: assignmentTypeParse
		}, {
			type: 'use.Review',
			url: 'cdr/reviews/Use',
			collectionParse: assignmentTypeParse
		}]
	});
});
